import { Logo } from "@/components/Logo";

const APP_URL = "https://mobile-replica-build.emergent.host";

export default function Header() {
    return (
        <header
            className="sticky top-0 z-40 bg-cream/95 backdrop-blur-md border-b border-black/5"
            data-testid="site-header"
        >
            <div className="px-5 h-[68px] flex items-center justify-between">
                <a href="#top" data-testid="header-logo">
                    <Logo size={32} />
                </a>
                <a
                    href={APP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-teal-dark font-semibold text-[15px] hover:text-teal transition-colors duration-200"
                    data-testid="header-login-link"
                >
                    Log in
                </a>
            </div>
        </header>
    );
}
